import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import Introduce from '@/components/Introduce'
import Join from '@/components/Join'
import News from '@/components/News'
import Product from '@/components/Product'
import Programme from '@/components/Programme'
// import Brief from '@/components/Introduce/brief'
// import Culture from '@/components/Introduce/culture'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
     {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/introduce',
      name: 'Introduce',
      component: Introduce
    },
    {
      path: '/join',
      name: 'Join',
      component: Join
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/programme',
      name: 'Programme',
      component: Programme
    },
    {
      path: '/equipmentdetail',
      name: 'equipmentDetail',
      component: resolve => require(['../components/detail/equipmentDetail.vue'], resolve),
    },
    {
      path: '/equipmentdetail/:id/:type',
      name: 'equipmentDetail',
      component: resolve => require(['../components/detail/equipmentDetail.vue'], resolve),
      props:true
    },
    {
    	path:'*',redirect:'/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js